import React, { useEffect, useState } from 'react';
import RootPortal from './RootPortal.react';
import Browser from '../util/Browser';

const URL = 'https://inmarket.com/adchoices/';
const iconStyle = {
  width: '100%',
  height: '100%',
};

const AdChoices = props => {
  const { isCeltra } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  const onClick = () => {
    if (!isExpanded) {
      setIsExpanded(true);
      return;
    }
    if (typeof window.willSendRequestWithURL === 'function') {
      window.willSendRequestWithURL(URL);
    } else {
      window.open(URL, '_blank');
    }
  };

  const topPadding = Browser.getTopPadding();
  const headerHeight = Browser.getHeaderHeight();

  const displayStyle = {
    zIndex: 2147483647,
    position: 'absolute',
    left: 0,
  };
  if (isCeltra) {
    displayStyle.top = topPadding ? `${topPadding}px` : '0px';
  } else {
    displayStyle.top = topPadding ? `${topPadding + headerHeight - 6}px` : `${headerHeight - 6}px`;
  }

  return (
    <div style={displayStyle}>
      <div
        data-testid="inmarket-adchoices-touch-area"
        style={{
          width: isExpanded ? '77px' : '30px',
          height: '30px',
        }}
        onClick={() => onClick()}
      >
        <div
          style={{
            width: isExpanded ? '77px' : '19px',
            height: '15px',
          }}
        >
          <img
            data-testid="adchoices-icon"
            alt="AdChoices"
            style={iconStyle}
            src={isExpanded ? '/img/header/adchoices-expanded.png' : '/img/header/adchoices.png'}
          />
        </div>
      </div>
    </div>
  );
};

export default AdChoices;
